import { Tag } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SivaBudgetStatus } from 'src/api/v2';

type Props = {
  status: SivaBudgetStatus;
};

const BudgetStatusTag: React.FC<Props> = ({ status }) => {
  const { t: tCommon } = useTranslation();

  if (status === SivaBudgetStatus.ChangeRequested) {
    return <Tag data-color={'danger' as const}>{tCommon('sentBack')}</Tag>;
  }

  if (status === SivaBudgetStatus.Approved) {
    return <Tag data-color={'success' as const}>{tCommon('approved')}</Tag>;
  }

  return <></>;
};

export default BudgetStatusTag;
